import { getAssetImageUrl, RecordingAsset } from '@kaltura-ott/tvpil-shared';

import { SCALING_IMAGE } from 'consts';
import { useCardIconsPaths } from 'hooks';

interface Props {
  recording: RecordingAsset;
  imageType: number | undefined;
  imageHeight: number;
  imageWidth: number;
}

export function useCardImage({ recording, imageWidth, imageType, imageHeight }: Props) {
  const backgroundImageUrl = getAssetImageUrl(recording.images, {
    type: imageType,
    width: imageWidth * SCALING_IMAGE,
    height: imageHeight * SCALING_IMAGE,
  });

  const { defaultImage } = useCardIconsPaths({ height: imageHeight, width: imageWidth });

  return {
    height: imageHeight,
    backgroundImageUrl,
    width: imageWidth,
    defaultImageUrl: defaultImage,
  };
}
